import { useTranslation } from "react-i18next";
import PackagePlans from "./PackagePlans.jsx";
import "./fonts.js";
import "./packages.scss";

/**
 * La escalera de paquetes del diseño del cliente, como se ve en /buy_package
 * (debajo va el flujo de pago). La portada pública tiene sus propias tarjetas,
 * hechas con las mismas funciones del catálogo.
 */
const PackagesShowcase = ({
  packages,
  loading,
  error,
  renderActions,
  selectedId,
}) => {
  const { t } = useTranslation();

  return (
    <div className="cp-paquetes">
      <section className="cp-planes-sec">
        <div className="cp-wrap">
          {loading && <p className="cp-nota">{t("packages.loading")}</p>}
          {error && <p className="cp-nota">{t("packages.loadError")}</p>}
          <PackagePlans
            packages={packages}
            renderActions={renderActions}
            selectedId={selectedId}
          />
        </div>
      </section>
    </div>
  );
};

export default PackagesShowcase;
